export default "__VITE_ASSET__a296e971__"